/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EjemplarFormAdminController', EjemplarFormAdminController);

    /* @ngInject */
    function EjemplarFormAdminController($timeout, $state, itemData, previousParams, Principal, AlertService,
                                         Biblioteca, RutasService, encuadernaciones) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';
        vm.urlBaseTranscrito = RutasService.getEjemplarTranscritoUrl(vm.item.id);
        vm.urlBaseDigitalizado = RutasService.getEjemplarDigitalizadoUrl(vm.item.id);

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole = Principal.identity().$$state.value.role;

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAdmin) {
                if (!esAdmin && vm.item.nombreUsuario != vm.userName) {
                    AlertService.warning("admin.ejemplar.error.unauthorized", null, 0);
                }
            });
        }

        // Guardar formulario
        //El ejemplar tiene una pagina digitalizada en blanco (utilizada para situar el boton de "añadir" en el componente
        //Si dicha pagina se elimina, se produce un efecto visual no deseado al darle a "guardar"
        //Por eso, creo una copia del ejemplar, que será al que le hago las modificaciones, y que le envío al servidor
        vm.save = function () {
            vm.otroEjemplar = angular.copy(vm.item);


            //No se sabe por que, pero se crea automaticamente una pagina nula al final de la lista de paginas, con esto se elimina
            if (vm.otroEjemplar.paginas.length == 1) {
                vm.otroEjemplar.paginas = [];
            }

            else {
                //Se eliminaba el último elemento (en blanco) Esto ahora se hace en el servidor, ya que de la otra manera, probocaba un comportamiento
                if (vm.otroEjemplar.paginas[(vm.otroEjemplar.paginas.length - 1)].nombre == null) {
                    vm.otroEjemplar.paginas.splice((vm.otroEjemplar.paginas.length - 1));
                }
            }
            vm.otroEjemplar.$save().then(function () {
                $state.go('admin/ejemplar/list', previousParams);
            });
        };

        vm.bibliotecaService = Biblioteca;
        vm.encuadernaciones = encuadernaciones;

    }

})(angular);
